import React, { useState } from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function BecomeMember() {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", qualification: "", specialization: "Ophthalmology", hospital: "", city: "", address: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/membership/apply", form);
      setDone(true);
      toast.success("Application submitted successfully");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <PageHero title="Become a Member" subtitle="Join a vibrant community of ophthalmologists advancing eye care in Ghaziabad and NCR." breadcrumbs={["Home", "Membership", "Become a Member"]} />
      <section className="section container-page grid grid-cols-1 lg:grid-cols-3 gap-10">
        <FadeUp className="lg:col-span-2 card-elev p-8">
          {done ? (
            <div className="text-center py-16">
              <CheckCircle2 size={56} className="text-brand-accent mx-auto" />
              <h3 className="font-serif text-2xl font-bold mt-4">Application received!</h3>
              <p className="text-brand-muted mt-2 max-w-md mx-auto">Thank you for applying. Our membership committee will review your application and contact you soon.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="md:col-span-2"><label className="form-label">Full Name *</label><input required value={form.full_name} onChange={upd("full_name")} className="form-input" data-testid="member-name" /></div>
              <div><label className="form-label">Email *</label><input required type="email" value={form.email} onChange={upd("email")} className="form-input" data-testid="member-email" /></div>
              <div><label className="form-label">Phone *</label><input required value={form.phone} onChange={upd("phone")} className="form-input" data-testid="member-phone" /></div>
              <div><label className="form-label">Qualification *</label><input required placeholder="e.g. MS Ophth, MBBS" value={form.qualification} onChange={upd("qualification")} className="form-input" data-testid="member-qual" /></div>
              <div><label className="form-label">Specialization</label><select value={form.specialization} onChange={upd("specialization")} className="form-input">{["Ophthalmology", "Retina", "Cornea", "Glaucoma", "Pediatric Ophthalmology", "Oculoplasty", "Refractive Surgery"].map((s) => <option key={s}>{s}</option>)}</select></div>
              <div><label className="form-label">Hospital / Clinic</label><input value={form.hospital} onChange={upd("hospital")} className="form-input" /></div>
              <div><label className="form-label">City</label><input value={form.city} onChange={upd("city")} className="form-input" /></div>
              <div className="md:col-span-2"><label className="form-label">Address</label><input value={form.address} onChange={upd("address")} className="form-input" /></div>
              <div className="md:col-span-2"><label className="form-label">Message</label><textarea rows={4} value={form.message} onChange={upd("message")} className="form-input"></textarea></div>
              <div className="md:col-span-2"><button disabled={submitting} className="btn-primary w-full sm:w-auto" data-testid="member-submit">{submitting ? "Submitting…" : "Submit Application"}</button></div>
            </form>
          )}
        </FadeUp>
        <FadeUp delay={0.15} className="space-y-5">
          <div className="card-elev p-6">
            <h4 className="font-serif text-lg font-bold">Membership Benefits</h4>
            <ul className="mt-4 space-y-3 text-sm text-brand-muted">
              {["Access to CME programs & workshops", "Discounted conference registration", "Academic mentorship & fellowships", "Society journal subscription", "Networking with senior consultants", "Certificates of participation & CME credits"].map((b) => (
                <li key={b} className="flex gap-2"><CheckCircle2 size={16} className="text-brand-accent shrink-0 mt-0.5" /> {b}</li>
              ))}
            </ul>
          </div>
          <div className="card-elev p-6 bg-brand-primary text-white">
            <h4 className="font-serif text-lg font-bold">Eligibility</h4>
            <p className="text-white/85 text-sm mt-3">Qualified ophthalmologists (MS/DNB Ophth), residents, fellows and medical professionals working in eye care are eligible to apply.</p>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
